import Vue from 'vue'

// ─────────────────────────────────────────────────────────────────────────────
// Temporary Disarm — end-user app (site-api, group ② in the API contract).
// Only "create" is a dedicated endpoint. Approve/decline of a pending temp-disarm
// reuse the shared approval-requests endpoints (siteApproval.js, action=temp_disarm),
// and "clear temp disarm" (re-arm early) is a normal partition arm via the
// existing partition-arming endpoint (sitePartition.updatePartitionArmingStatus).
// ─────────────────────────────────────────────────────────────────────────────

export default {
  apiPrefix: '/api/v2/sites',

  // POST /api/v2/sites/{site_id}/partition-arming/temp-disarm  (appCreateTempDisarm)
  // partitions: [{ partitionId, duration }]  (duration in seconds)
  createTempDisarm: function ({ siteId, partitions, reasonPresetId }) {
    const data = {
      temp_disarm_partitions: (partitions || []).map(p => ({
        partition_id: p.partitionId,
        temp_disarm_duration: p.duration,
      })),
    }
    if (reasonPresetId !== undefined && reasonPresetId !== null) data.reason_preset_id = reasonPresetId
    return Vue.http.post(
      Vue.env.apiPath + `${this.apiPrefix}/${siteId}/partition-arming/temp-disarm`,
      data,
      Vue.auth.getBearerHeader()
    )
  },
}
